module.exports = __webpack_public_path__ + "img/xnjdcbs-logo.645d88b3.png";